import React, { useRef } from "react";
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import './styles.css';

// import required modules
import {} from "swiper/modules";
import "./Transcation.css";
import img1 from "../Assets/lqfirspeak-1.svg";
import img2 from "../Assets/stack.png";
import img3 from "../Assets/laptop.png";
import img4 from "../Assets/lqfirspeak-2.svg";
import img5 from "../Assets/mobile.png";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";

export default function Transcation() {
  const swiperRef = useRef();

  return (
    <div className="main_transcaion_page">
      <div className="container">
        <div className="row trans_sc pt-5">
          <div className="col-md-5">
            <div className="trans_conent">
         
              <h1>The Triumph Token(TRH) Ecosystem</h1>
            </div>
            <div className="arrow_group">
              <div className="box_arrow me-3">
                <FaArrowLeftLong
                  style={{ fontSize: "1.3rem" }}
                  onClick={() => swiperRef.current.slidePrev()}
                />
              </div>
              <div
                className="box_arrow"
                onClick={() => swiperRef.current.slideNext()}
              >
                <FaArrowRightLong style={{ fontSize: "1.3rem" }} />
              </div>
            </div>
          </div>
          <div className="col-md-7 mt-3 mt-md-0 bg_card">
            <>
              <Swiper
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                }}
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                  },
                }}
                // loop={true}
                modules={[]}
                className="mySwiper"
              >
                <SwiperSlide>
                  <div className="trns_box_content text-start">
                    <div className="card_first_img">
                      <img src={img5} alt="" />
                    </div>
                  
                    <h6>NFT Collection</h6>
                    <p>
                    In December, Triumph plans to launch an NFT collection featuring memorable crypto moments from 2024.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="trns_box_content text-start">
                    <div className="card_first_img">
                      <img src={img2} alt="" />
                    </div>
                   
                    <h6>Staking Rewards</h6>
                    <p>
                    Triumph offers staking with various advantages and bonuses:
• 1-month stake generates 6% APY with locked tokens.
• Longer stakes offer higher APY and additional perks like free subscriptions to Spotify, YouTube Premium, or Netflix.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="trns_box_content text-start">
                    <div className="card_first_img">
                      <img src={img3} alt="" />
                    </div>
                 
                    <h6>No Vesting or TGE Period</h6>
                    <p>
                    Triumph provides customers with the freedom to buy or sell tokens without restrictions, ensuring a seamless trading experience.
                    </p>
                  </div>
                </SwiperSlide>
                {/* <SwiperSlide>
                  {" "}
                  <div className="trns_box_content text-start">
                    <div className="card_first_img">
                      <img src={img4} alt="" />
                    </div>
             
                    <h6>Multi Family Dwelling Units</h6>
                    <p>
                    Build new townhomes, condominiums, modular homes, and apartment complexes that are designed for families and individualities.
                    </p>
                  </div>
                </SwiperSlide> */}
              </Swiper>
            </>
          </div>







          <div className="clr_bg"></div>
        </div>
      </div>
    </div>
  );
}
